import React from 'react'
import Greenenergysolar from "../../components/User/About/Greenenergysolar";
import CompanyOverview from '../../components/User/About/Companyoverview';
import WorkProcess from '../../components/User/About/Workprocess';
import LatestProjects from '../../components/User/About/Latestprojects ';
import StatsBanner from '../../components/User/About/Statsbanner';
import SimpleBanner from '../../components/User/Common/SimpleBanner';
import GetInvolved from '../../components/User/Home/GetInvolved';

const About = () => {
  return (
    <div>
      <SimpleBanner title='About Us' subheading='Home > About Us'/>
      <Greenenergysolar/>
      <CompanyOverview/>
      <WorkProcess/>
      <LatestProjects/>
      <StatsBanner/>
      <GetInvolved/>
    </div>
  )
}

export default About;